import { configureStore } from "@reduxjs/toolkit";
import { customReducer } from "./Reducers";
import { counterSlice } from "./notificationReducer";
import { finYearSlice } from "./finYearReducer";
import { ChooseMemberSlice } from "./chooseMember";

const store = configureStore({
  reducer: {
    customReducer: customReducer,
    notification: counterSlice.reducer,
    updateFinYear: finYearSlice.reducer,
    setIsMemberChoose: ChooseMemberSlice.reducer,
  },
});

export default store;
